import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import en from './en.json'
import hn from './hn.json'
import mr from './mr.json'

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    resources: {
      en: { translation: en },
      hn: { translation: hn },
      mr: { translation: mr },
    },
    interpolation: {
      escapeValue: false,
    },
  })

export default i18n
